import { render } from "./LogoBugTracker.vue?vue&type=template&id=39172376"
const script = {}

import "./LogoBugTracker.vue?vue&type=style&index=0&id=39172376&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__